import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const MoveInstalledBaseNodePreview = gql`
    query MoveInstalledBaseNodePreview ($id: ID!, $targetParentNodeId: ID!) {
        moveInstalledBaseNodePreview (id: $id, targetParentNodeId: $targetParentNodeId) {
            allowed
            blockingReasons
            removeForm {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
            installForm {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
